import { render, staticRenderFns } from "./NotificationsHome.vue?vue&type=template&id=00a93111&"
import script from "./NotificationsHome.vue?vue&type=script&lang=js&"
export * from "./NotificationsHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports